import { ERROR_CONSULTA_SERVIDOR } from "./actionTypes";

export const errorConsultaServidor = (error, missatgePerUsuari) => {
  return {
    type: ERROR_CONSULTA_SERVIDOR,
    error: error.message ? error.message : error,
    missatgePerUsuari
  };
};
